import { Stack } from '@mui/material';
import styled from 'styled-components';

export const PipelineStepStatusPopoverHeader = styled(Stack)`
  && {
    flex-direction: row;
    gap: 0.375rem;
    align-items: center;

    & > svg {
      width: 1.25rem;
      height: 1.25rem;
      color: ${({ theme }) => theme.palette.text.primary};
    }
  }
`;
